export default __webpack_public_path__ + "static/file-to-data-alt-95e6ac29d1e03a10011f91fc4856eb15.gif";